import { type HereAndNowTab, useHaNData, useRefreshBucket } from "@lib/logic";
import { useFeatureToggle } from "@hooks";
import { getDeskAmenityIcon, getRoomEquipementIcon } from "@utils";

import { useHaNBuilding } from "../data/useHaNBuilding";
import { refreshClock } from "../state/refresh/refreshClock";
import { haNSession } from "../state/session/haNSession";
import { useAvailableTabs } from "../useHaNTabs";

type HaNContextOptions = {
  isSearching: boolean;
};

/** The shared H&N data, with web's refresh clock, session store, building deep link, feature flags and icons. */
export const useHaNContextValue = (tab: HereAndNowTab, { isSearching }: HaNContextOptions) => {
  const enabledFeatures = useFeatureToggle();
  const availableTabs = useAvailableTabs();
  const bucket = useRefreshBucket(refreshClock);
  const building = useHaNBuilding(bucket);

  return useHaNData({
    tab,
    isSearching,
    bucket,
    building,
    session: haNSession,
    availableTabs,
    enabledFeatures,
    getDeskAmenityIcon,
    getRoomEquipementIcon,
  });
};
